export class WidgetTableColumn {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "key",
            "baseName": "key",
            "type": "string",
            "format": ""
        },
        {
            "name": "title",
            "baseName": "title",
            "type": "string",
            "format": ""
        },
        {
            "name": "field",
            "baseName": "field",
            "type": "FieldConfig",
            "format": ""
        },
        {
            "name": "align",
            "baseName": "align",
            "type": "WidgetTableColumnAlignEnum",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return WidgetTableColumn.attributeTypeMap;
    }
    constructor() {
    }
}
export var WidgetTableColumnAlignEnum;
(function (WidgetTableColumnAlignEnum) {
    WidgetTableColumnAlignEnum["Left"] = "left";
    WidgetTableColumnAlignEnum["Right"] = "right";
    WidgetTableColumnAlignEnum["Center"] = "center";
})(WidgetTableColumnAlignEnum || (WidgetTableColumnAlignEnum = {}));
